import * as React from 'react'

export const GroupToggle = ({index, name, expanded, isLoading, onClick}) => {
  const iconClass = expanded ? "ss-navigatedown" : "ss-navigateup"
  return (
    <span style={{cursor: 'pointer', marginRight: '5px'}} onClick={() => onClick(index)}>
      <span style={{marginRight: '5px'}} className={iconClass}></span>
      <strong>{name}</strong>&nbsp;{isLoading &&
    <i className="fas fa-spinner fa-spin fa-sm"></i>}
    </span>
  )
}